import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _44a40dd9 = () => interopDefault(import('..\\pages\\document-error.vue' /* webpackChunkName: "pages_document-error" */))
const _5d638fcc = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _da78a656 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _4b016f8e = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _fcc74854 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _84a30df6 = () => interopDefault(import('..\\pages\\signature.vue' /* webpackChunkName: "pages_signature" */))
const _4d23ae73 = () => interopDefault(import('..\\pages\\ssuccess.vue' /* webpackChunkName: "pages_ssuccess" */))
const _291c6c10 = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _0d16cb24 = () => interopDefault(import('..\\pages\\timeout.vue' /* webpackChunkName: "pages_timeout" */))
const _2d798e73 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _7f61a094 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _7f457192 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _7f0d138e = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _7ef0e48c = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _15952a12 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _64d2977c = () => interopDefault(import('..\\pages\\patient\\patient-information.vue' /* webpackChunkName: "pages_patient_patient-information" */))
const _3b163361 = () => interopDefault(import('..\\pages\\patient\\success.vue' /* webpackChunkName: "pages_patient_success" */))
const _7f1f99f4 = () => interopDefault(import('..\\pages\\representative\\patient-information.vue' /* webpackChunkName: "pages_representative_patient-information" */))
const _ffd6d7da = () => interopDefault(import('..\\pages\\representative\\success.vue' /* webpackChunkName: "pages_representative_success" */))
const _4efd8e9f = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/document-error",
    component: _44a40dd9,
    name: "document-error"
  }, {
    path: "/eligibility",
    component: _5d638fcc,
    name: "eligibility"
  }, {
    path: "/error",
    component: _da78a656,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _4b016f8e,
    name: "have-a-card"
  }, {
    path: "/rejection",
    component: _fcc74854,
    name: "rejection"
  }, {
    path: "/signature",
    component: _84a30df6,
    name: "signature"
  }, {
    path: "/ssuccess",
    component: _4d23ae73,
    name: "ssuccess"
  }, {
    path: "/success",
    component: _291c6c10,
    name: "success"
  }, {
    path: "/timeout",
    component: _0d16cb24,
    name: "timeout"
  }, {
    path: "/upload-documents",
    component: _2d798e73,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _7f61a094,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _7f457192,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _7f0d138e,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _7ef0e48c,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _15952a12,
    name: "errors-500"
  }, {
    path: "/patient/patient-information",
    component: _64d2977c,
    name: "patient-patient-information"
  }, {
    path: "/patient/success",
    component: _3b163361,
    name: "patient-success"
  }, {
    path: "/representative/patient-information",
    component: _7f1f99f4,
    name: "representative-patient-information"
  }, {
    path: "/representative/success",
    component: _ffd6d7da,
    name: "representative-success"
  }, {
    path: "/",
    component: _4efd8e9f,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
